<template>
  <div class="form-block">
    <div class="form-content form-approve">
      <div class="form-cell full-cell">
        <div class="form-label ">付款账户</div>
        <div class="form-value ">
          <el-input v-model="form.payAccount" maxlength="100" placeholder="请输入付款账户"></el-input>
        </div>
      </div>
      <div class="form-cell full-cell">
        <div class="form-label ">付款金额</div>
        <div class="form-value ">
          <el-input v-model="form.payMoney" placeholder="请输入金额"></el-input>
        </div>
      </div>
      <div class="form-cell full-cell">
        <div class="form-label  ">付款截图</div>
        <div class="form-value ">
          <up-load-img ref="uploadImg" funcName="CoDeposit" :multiple="false"/>
        </div>
      </div>
      <div class="form-cell full-cell">
        <div class="form-label ">是否开具收据</div>
        <div class="form-value ">
          <el-radio-group v-model="form.issueReceipt">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="form-cell full-cell" v-if="form.issueReceipt">
        <div class="form-label ">收件人</div>
        <div class="form-value ">
          <el-input v-model="form.realName " maxlength="20" placeholder="请输入收件人"></el-input>
        </div>
      </div>
      <div class="form-cell full-cell" v-if="form.issueReceipt">
        <div class="form-label ">联系方式</div>
        <div class="form-value ">
          <el-input v-model="form.phone" maxlength="30" placeholder="请输入联系方式"></el-input>
        </div>
      </div>
      <div class="form-cell full-cell" v-if="form.issueReceipt">
        <div class="form-label ">Email</div>
        <div class="form-value ">
          <el-input v-model="form.email" maxlength="50" placeholder="请输入Email"></el-input>
        </div>
      </div>
      <div class="form-cell full-cell">
        <div class="form-label"></div>
        <div class="form-value ">
          <el-button type="primary" class="submit-btn" @click="submitProof">提交</el-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import UpLoadImg from "../refund/upload-img";
  import OrderService from "../../apis/orderService";
  import BondService from "../../apis/bondService";


  export default {
    name: "bond-proof",
    components: {UpLoadImg},
    data() {
      return {
        form: {
          issueReceipt: true
        },
        rules: [
          {
            prop: "payAccount", message: "请输入付款账户", required: true
          },
          {
            prop: "payMoney", message: "请输入付款金额", required: true, validate(value) {
              if (isNaN(value)) throw `付款金额必须为数字`;
              if (value > 10000000) throw `付款金额不能大于10000000`;
              if (value <= 0) throw `付款金额必须大于0`;
              if (value.toString().split(".")[1] && value.toString().split(".")[1].length > 2) throw `付款金额最多两位小数`;
            }
          },
          {
            prop: "payPic", message: "请上传付款截图", required: true
          },
          {
            prop: "realName", validate(value, form) {
              if (form.issueReceipt && !value) throw `请输入收件人`
            }
          },
          {
            prop: "phone", validate(value, form) {
              if (form.issueReceipt && !value) throw `请输入联系方式`
            },
          },
          {
            prop: "email", validate(value, form) {
              if (form.issueReceipt && !value) throw `请输入Email`;
              if (form.issueReceipt && !/^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(value)) throw `请输入正确的Email`;
            }
          },
        ]
      }
    },
    methods: {
      checkForm(postData) {
        this.rules.forEach(rule => {
          if (rule.required && !postData[rule.prop]) throw rule.message;
          rule.validate && rule.validate(postData[rule.prop], postData);
        })
      },
      async submitProof() {
        const payPic = this.$refs.uploadImg.saveUrls[0];
        const postData = {...this.form, payPic};
        try {
          this.checkForm(postData);
        } catch (e) {
          return this.$message.warning(e);
        }
        if (postData.issueReceipt == 0) {
          delete postData.realName;
          delete postData.phone;
          delete postData.email;
        }
        postData.payMoney = OrderService.toFen(postData.payMoney);
        await BondService.addCoDeposit(postData);
        this.$message.success("保存成功");
        this.$router.go(-1);
      }
    }
  }
</script>

<style scoped lang="scss">
  .form-block {
    position: relative;
    padding-left: 20px;
    padding-top: 30px;
    &.refund-gap {
      border-bottom: 10px solid #f0f6fc;
    }

    .form-title {
      height: 32px;
      line-height: 32px;
      display: flex;
      font-size: 18px;
      color: #333;
      .form-icon {
        width: 4px;
        background-color: #1B9AEE;
        margin-right: 20px;
      }
      .more-order {
        color: #1890FF;
        font-size: 12px;
        display: flex;
        justify-content: center;
        cursor: pointer;

      }
    }
    .form-content {
      margin-top: 30px;
      display: flex;
      flex-wrap: wrap;
      &.form-approve {
        margin-top: 0;
      }

      .form-cell {
        display: flex;
        width: 400px;
        font-size: 14px;
        color: #333;
        margin-bottom: 35px;
        &.full-cell {
          width: 90%;
          .form-value {
            width: 400px;
          }
          &:nth-of-type(even) {
            margin-left: 0;
          }
        }

        &:nth-of-type(even) {
          min-width: 55%;
          margin-left: 60px;
        }
        .form-label {
          color: #666;
          min-width: 100px;
          &.required {
            position: relative;
            &:before {
              content: "*";
              position: absolute;
              top: 0;
              left: -8px;
              color: red;
            }
          }
        }
      }
    }
    .submit-btn {
      width: 100%;
      padding: 18px 20px;
      font-size: 18px;
    }
  }
</style>